export enum NetworkIntegrityProviderTypes {
  Network = "Network",
  Servicing = "Servicing"
}